import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Form,Row,Col} from 'react-bootstrap';
//import ScrollAnimation from "react-animate-on-scroll";
import { useStaticQuery, graphql } from "gatsby";
import HTMLReactParser from 'html-react-parser';
import "./Foundation.scss"
// markup
const Foundation = () => {

  const data = useStaticQuery(graphql`
    query {
      glstrapi {

        globalModule {
          Mission
          Values
          Vision_Mission_Main_Title
          Vision
        }

      }
    }
  `);

  const content = data.glstrapi.globalModule


    return (
        <React.Fragment>
            <section className="foundation">
           <Container className="pad-50">
                  <Row>
                      <Col md={12} xl={3} className="pr-xl-0">
                      <div animateIn='fadeIn' delay={200} animateOnce>
                      <div className="foundation-info">
                          <h2>{content.Vision_Mission_Main_Title}</h2>
                      </div>
                      </div>
                      </Col>
                      <Col md={12} xl={3 } className="p-xl-0">
                      <div animateIn='fadeInUp'  delay={400} animateOnce>
                      <div className="foundation-details">
                        <span className="icons">
                           <i className="icon-vision"></i>
                        </span>
                        <span className="sm-text">Vision</span>

                        {HTMLReactParser(content.Vision.replace(/\n/g,'<br />'))}

                      </div>
                      </div>
                      </Col>
                      <Col md={12} xl={3} className="p-xl-0">
                      <div animateIn='fadeInUp' delay={500} animateOnce>
                      <div className="foundation-details mission">
                        <span className="icons">
                           <i className="icon-mission"></i>
                        </span>
                        <span className="sm-text">Mission</span>

                        {HTMLReactParser(content.Mission.replace(/\n/g,'<br />'))}
                        
                      </div>
                      </div>
                      </Col>
                      <Col md={12} xl={3} className="p-xl-0">
                      <div animateIn='fadeInUp' delay={600} animateOnce>
                      <div className="foundation-details values">
                        <span className="icons">
                           <i className="icon-diamond"></i>
                        </span>
                        <span className="sm-text">Values</span>

                        {HTMLReactParser(content.Values.replace(/\n/g,'<br />'))}
                        
                      </div>
                      </div>
                      </Col>
                  </Row>
             </Container>
            </section>
        </React.Fragment>
    )
}
export default Foundation